export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.directive('click-outside', {
    mounted: (el, binding) => {
      el.clickOutsideEvent = event => {
        const isDatepicker = binding.instance?.datepickerPopupClass
        
        /**
         * checks if instance has `datepickerPopupClass`
         * then checks if clicked target is inside `datepickerPopup` element and ignores the click
         */
        if (isDatepicker) {
          const popupEl = document.querySelector(`.${binding.instance.datepickerPopupClass}`)
          const target = event.target
          
          if (popupEl && (popupEl === target || popupEl.contains(target))) {
            return
          }
        }

        if (!(el === event.target || el.contains(event.target))) {
          binding.value(event)
        }
      }
      document.addEventListener('click', el.clickOutsideEvent)
    },

    unmounted: el => {
      document.removeEventListener('click', el.clickOutsideEvent)
    }
  })
})
